import { cn } from "@/libs/utils";
import { CSSProperties, ReactNode } from "react";

type Props = {
  as?: "p" | "span" | "div" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  text?: string | ReactNode;
  size?: number | string;
  weight?: number;
  color?: string;
  lineHeight?: number | string;
  sup?: string;
  className?: string;
  style?: CSSProperties;
  [key: string]: any;
};

export function Text({
  className = "",
  lineHeight,
  sup = "",
  as = "p",
  text = "",
  color,
  weight,
  size,
  style = {},
  ...rest
}: Props) {
  const Element = as;

  const _style: CSSProperties = {
    fontWeight: weight,
    color,
    fontSize: size
      ? typeof size === "string"
        ? size
        : `${size}px`
      : undefined,
    lineHeight: lineHeight
      ? typeof lineHeight === "string"
        ? lineHeight
        : `${lineHeight}px`
      : undefined,
    ...style,
  };

  return (
    <Element style={_style} className={cn(className)} {...rest}>
      {text}
      {sup && <sup>{sup}</sup>}
    </Element>
  );
}

export const GrayText = ({
  text,
  className,
}: {
  text: string;
  className?: string;
}) => <Text className={cn(className, "text-222222")} text={text} />;
